/**
 * Multi-Variant Bundle Products Display
 * Handles showing/hiding products based on selected variant
 */

document.addEventListener('DOMContentLoaded', () => {
  class MultiVariantBundle {
    constructor(element) {
      this.bundle = element;
      this.productId = this.bundle.dataset.productId;
      this.selectedVariantId = parseInt(this.bundle.dataset.selectedVariantId);
      this.productCards = this.bundle.querySelectorAll('.multi-variant-bundle__product-card');
      
      this.init();
    }

    init() {
      // Listen for variant changes
      const variantRadio = document.querySelector('product-options-root')
      if(variantRadio){
        window.on(`theme:product:${variantRadio.dataset.id}:variantChanged`, ({detail: {variant}}) => {
          this.handleVariantChange(variant)
        })
      }
      
      
      // Show products for initially selected variant
      this.showProductsForVariant(this.selectedVariantId);
    }

    handleVariantChange(variant) {
      if (variant && variant.id) {
        const newVariantId = parseInt(variant.id);
        this.selectedVariantId = newVariantId;
        this.bundle.dataset.selectedVariantId = newVariantId;
        
        // Show/hide products based on new variant
        this.showProductsForVariant(newVariantId);
        
        // Dispatch event that products have been updated
        document.dispatchEvent(new CustomEvent('bundle:products-updated', {
          detail: { 
            variantId: newVariantId,
            visibleProducts: this.getVisibleProducts()
          }
        }));
      }
    }

    showProductsForVariant(variantId) {
      this.productCards.forEach(card => {
        const parentVariantId = parseInt(card.dataset.parentVariantId);
        
        if (parentVariantId === variantId) {
          card.style.display = '';
          card.classList.add('is-visible');
          card.classList.remove('is-hidden');
        } else {
          card.style.display = 'none';
          card.classList.add('is-hidden');
          card.classList.remove('is-visible');
        }
      });
    }

    getVisibleProducts() {
      const visibleProducts = [];
      this.productCards.forEach(card => {
        if (card.classList.contains('is-visible')) {
          visibleProducts.push({
            productId: card.dataset.productId,
            variantId: card.dataset.variantId,
            quantity: parseInt(card.dataset.quantity) || 1
          });
        }
      });
      return visibleProducts;
    }

    // Public method to get current variant's products
    getCurrentProducts() {
      return this.getVisibleProducts();
    }
  }

  // Initialize all multi-variant bundle widgets
  function initMultiVariantBundles() {
    const bundles = document.querySelectorAll('.multi-variant-bundle');
    bundles.forEach(bundle => {
      // Store instance on the element for external access
      bundle.multiVariantBundleInstance = new MultiVariantBundle(bundle);
    });
  }

  // Initialize bundles
  initMultiVariantBundles();

  // Re-initialize if content is dynamically loaded
  document.addEventListener('shopify:section:load', initMultiVariantBundles);

  // Export for use in other scripts if needed
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = MultiVariantBundle;
  }
});
